module.exports = __webpack_public_path__ + "img/search.664e0a09.svg";